/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Box, Container, Grid } from '@material-ui/core';

import useTranslate, {
  useMarkdownTranslate,
} from 'hooks/useTranslate/useTranslate';
import PageContainer from 'components/PageContainer';
import Title from 'components/Title';

import styles from './styles';
import { useMemo } from 'react';

interface Acceptance {
  otp: string | null | undefined;
}

const AcceptanceView: React.FC<Acceptance> = props => {
  const { otp } = props;
  const tMd = useMarkdownTranslate();
  const t = useTranslate();
  const icon = useMemo(() => t('magicLink.magicLinkAcceptance.icon'), [t]);

  return (
    <Container maxWidth="md">
      <PageContainer>
        <Grid container>
          <Grid item xs={12}>
            <Box css={styles.headingContainer}>
              <Title>{tMd('magicLink.magicLinkAcceptance.title')}</Title>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box mb={3} css={styles.normalText}>
              {otp === null
                ? tMd('magicLink.magicLinkAcceptance.subTitleNoOtp')
                : tMd('magicLink.magicLinkAcceptance.subTitle')}
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box mb={3} css={styles.otpSection}>
              {otp}
            </Box>
          </Grid>

          <Grid container justify="center">
            <Grid item xs={6} md={3}>
              {icon ? (
                <img
                  alt=""
                  aria-hidden="true"
                  css={styles.mobileSuccessImage}
                  src={`data:${icon}`}
                />
              ) : null}
            </Grid>
          </Grid>
        </Grid>

        <Box mb={5} css={styles.imageContainer}></Box>
      </PageContainer>
    </Container>
  );
};

export default AcceptanceView;
